import React, { useEffect } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, Legend, LabelList } from 'recharts';
import ResponsiveLegend from "utils/ResponsiveLegendChart";
import { formateMonthName } from "utils/formats";

export default function DespesaCartaoChart({ despesaCartaoData }) {

    const [chartAndTableData, setChartAndTableData] = React.useState([]);
    const { getLegendPosition, windowWidth } = ResponsiveLegend();

    useEffect(() => {
        if (despesaCartaoData && despesaCartaoData.length > 0) {
            let mappedData = despesaCartaoData.map((data) => ({
                name: formateMonthName(data.mesAno),
                aluguelMaquinaPdv: data.aluguelMaquinaPdv,
                taxaCartaoMDRPdv: data.taxaCartaoMDRPdv,
                percentualAluguelMaquina: data.percentualAluguelMaquina,
                percentualTaxaCartaoMDR: data.percentualTaxaCartaoMDR,
                aluguelMaquina: data.aluguelMaquina,
                taxaCartaoMDR: data.taxaCartaoMDR,
            }));
            setChartAndTableData(mappedData);
        }
    }, [despesaCartaoData]);

    const CustomTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            const data = payload[0].payload;
            const aluguelMaquinaPercentual = `${new Intl.NumberFormat('pt').format(data.percentualAluguelMaquina)}%`
            const taxaCartaoMDRPercentual = `${new Intl.NumberFormat('pt').format(data.percentualTaxaCartaoMDR)}%`
            const pdvAluguelMaquina = `R$ ${data.aluguelMaquinaPdv.toLocaleString('pt-BR').split(',')[0]}`;
            const pdvTaxaCartaoMDR = `R$ ${data.taxaCartaoMDRPdv.toLocaleString('pt-BR').split(',')[0]}`;
            return (
                <div className="custom-tooltip" style={{ backgroundColor: '#fff', padding: '10px', border: '1px solid #ccc' }}>
                    <p>{data.name}</p>
                    <p>ALUGUEL DA MÁQUINA %: {aluguelMaquinaPercentual}</p>
                    <p>TAXA CARTÃO MDR %: {taxaCartaoMDRPercentual}</p>
                    <p>ALUGUEL DA MÁQUINA/PDV: {pdvAluguelMaquina}</p>
                    <p>TAXA CARTÃO MDR/PDV: {pdvTaxaCartaoMDR}</p>
                </div>
            );
        }
        return null;
    };

    return (
        <div>
            <ResponsiveContainer width='99%' height={400}>
                <ComposedChart
                    width={1200}
                    height={400}
                    data={chartAndTableData}
                    margin={{
                        top: 20,
                        right: 30,
                        left: 5,
                        bottom: 10
                    }}
                >
                    <XAxis
                        dataKey="name"
                        stroke="#000" 
                        axisLine={false}
                        tickLine={false} 
                        style={{textAlign: "center",fontWeight: 'bold'}}
                    />
                    <YAxis hide />
                    <Tooltip content={<CustomTooltip />} />
                    <Legend
                        align={windowWidth > 600 ? 'left' : 'center'}
                        layout={windowWidth > 600 ? 'vertical' : 'horizontal'}
                        iconSize={10}
                        wrapperStyle={(windowWidth > 600) ? { ...getLegendPosition(),  minWidth: '140px', width: '140px',maxWidth: '140px'} : { ...getLegendPosition() }}
                        formatter={(value, entry) => <span style={{ color: '#000', fontSize: '10px' }}>{value}</span>}
                        payload={[
                            { value: 'ALUGUEL DA MÁQUINA %', type: "rect", color: "#e0e4ed" },
                            { value: 'TAXA CARTÃO MDR %', type: "rect", color: "#d7ebe0" },
                            { value: 'ALUGUEL DA MÁQUINA/PDV', type: "line", color: "#606f90" },
                            { value: 'TAXA CARTÃO MDR/PDV', type: "line", color: "#42a76f" },
                        ]}
                    />
                    <Bar
                        dataKey="percentualTaxaCartaoMDR"
                        name="TAXA CARTÃO MDR %"
                        fill="#d7ebe0"
                        stackId="123"
                    />
                    <Bar
                        dataKey="percentualAluguelMaquina"
                        name="ALUGUEL DA MÁQUINA %"
                        fill="#e0e4ed"
                        stackId="123"
                    />
                    <Line type="monotone" dataKey="percentualAluguelMaquina" name="CREDITO/PDV" stroke="#606f90" dot={false}>
                        <LabelList
                            dataKey="aluguelMaquinaPdv"
                            fill="#606f90"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                    <Line type="monotone" dataKey="percentualTaxaCartaoMDR" name="DEBITO/PDV" stroke="#42a76f" dot={false}>
                        <LabelList
                            dataKey="taxaCartaoMDRPdv"
                            fill="#42a76f"
                            formatter={(x) => x.toLocaleString('pt-BR').split(',')[0]}
                            fontSize="10px"
                            position="top"
                        />
                    </Line>
                </ComposedChart>
            </ResponsiveContainer>
            <div style={{ marginRight: '40px' }}>
                <table
                    style={{
                        width: '100%',
                        borderTop: '1px solid #000',
                        borderBottom: '1px solid #000',
                        overflow: 'auto',
                        tableLayout: 'fixed'
                    }}>
                    <tbody>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>ALUGUEL DA MÁQUINA</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.aluguelMaquina.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.percentualAluguelMaquina)}%`}
                                </td>
                            ))}
                        </tr>
                        <tr>
                            <th style={{ minWidth: '135px', width: '135px' }}>TAXA CARTÃO MDR</th>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {item.taxaCartaoMDR.toLocaleString('pt-BR').split(',')[0]}
                                </td>
                            ))}
                        </tr>
                        <tr style={{ border: '1px dotted #000' }}></tr>
                        <tr style={{ borderBottom: '1px solid #000', }}>
                            <td><i>(TOTAL%)</i></td>
                            {chartAndTableData.map((item, index) => (
                                <td key={index} style={{ textAlign: 'center', fontSize: '10px' }}>
                                    {`${(item.percentualTaxaCartaoMDR)}%`}
                                </td>
                            ))}
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
}
